import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import {
  LOGIN_CONSOLE,
  LOGIN_CONSOLE_SUCCESS,
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_CO_USER,
  LOGIN_CO_USER_SUCCESS,
  API_ERROR,
} from "./actionTypes"
import {
  apiError,
  loginConsoleSuccess,
  loginUserSuccess,
  loginCoUserSuccess,
  logoutSuccess,
} from "./actions"

import {
  logout,
  loginConsoleAuth,
  loginSignUpUrlAuth,
  loginCoSignUpUrlAuth,
  setJwt,
  setSession,
  setCurrentUser,
  getCurrentUser,
} from "../../helpers/AuthType/authService"

import {
  getPage,
  getPages,
  setPages,
  initPages,
  getPagesById,
  updatePagetracker,
} from "../../helpers/PageTracker/page-tracker-backend"

function* loginConsole({ payload: { user, history } }) {
  try {
    const response = yield call(loginConsoleAuth, {
        code: user.code,
        pin: user.pin,
      })
      
      if (response.status !== 200) {
        yield put(
          apiError("Please Consultant ESF Merchant Services for API Set Up")
        )
      } else {
        const { headers, data: session } = response

        setJwt(headers["x-esf-apply-auth-token"])

        setSession(session)

        let {
          cookie,
          merchant,
        } = session

        setCurrentUser(cookie)

        yield put(loginConsoleSuccess({ merchant}))
      }
    
  } catch (error) {
    console.log({error})
    yield put(apiError(error.message))
  }
}

function* loginSignUpUrl({ payload: { user, history } }) {
  try {
    let {identifier} = user
    
    const response = yield call(loginSignUpUrlAuth, {identifier})
      
      if (response.status !== 200) {
        yield put(
          apiError("Please Consultant ESF Merchant Services for API Set Up")
        )
      } else {

        const { headers, data: session } = response

        setJwt(headers["x-esf-apply-auth-token"])

        setSession(session)

        let {
          cookie,
          merchant,
        } = session

        setCurrentUser(cookie)

        yield put(loginUserSuccess({ merchant}))
      }
    
  } catch (error) {
    console.log({error})
    yield put(apiError(error.message))
  }
}

function* loginCoSignUpUrl({ payload: { user, history } }) {
  try {
    
    let {identifier} = user
    
    const response = yield call(loginCoSignUpUrlAuth, {url_identifier : identifier});
      
      if (response.status !== 200) {
        yield put(
          apiError("Please Consultant ESF Merchant Services for API Set Up")
        )
      } else {

        const { headers, data: session } = response

        setJwt(headers["x-esf-apply-auth-token"])

        setSession(session)

        let {
          cookie,
          merchant,
        } = session

        setCurrentUser(cookie)

        yield put(loginCoUserSuccess({merchant}))
      }    
  } catch (error) {
    console.log({error})
    yield put(apiError(error.message))
  }
}

function* logoutUser({ payload: { history } }) {
  try {    
    const response = yield call(logout); 
    
    var path = "/application-complete";
    
    yield put(logoutSuccess())    
    
    history(path)
    
  } catch (error) {
    console.log({error})
    yield put(apiError(error.message))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_CONSOLE, loginConsole)
  yield takeEvery(LOGIN_USER, loginSignUpUrl)
  yield takeEvery(LOGIN_CO_USER, loginCoSignUpUrl)
  yield takeEvery(LOGOUT, logoutUser)
}

export default authSaga
